import React, { useEffect, useState } from 'react';

import type { TopTagResponse } from '@schibsted/frapi-schema';

import { console } from '../../../../core/system/console/index.js';
import { sectionMappings } from '../../layouts/front/sectionHelpers.js';
import { makeTagTitle } from '../articles/helpers.js';
import { LinkWithPulse } from '../../../pulse/index.js';

interface TopTagsProps {
  section: string;
}

export const TopTags: React.FC<TopTagsProps> = ({ section }) => {
  const [topTags, setTopTags] = useState<TopTagResponse>();

  useEffect(() => {
    (async () => {
      try {
        const sectionId = sectionMappings[section]?.sectionId;
        if (sectionId) {
          const res = await fetch(
            `/api/top-tags?sectionIds=${sectionMappings[section]?.sectionId}&tagTypes=machine&phrase=vink&limit=15`,
          );
          const json = await res.json();
          setTopTags(json);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [section]);

  return (
    <div className="top-tag-container">
      <h2 className="top-tag-title">Mye brukt:</h2>
      <div className="top-tags">
        {topTags?.items.map((t) => {
          const tagTitle = makeTagTitle(t.title);

          return (
            <LinkWithPulse
              objectId={`top-tag:${section}`}
              name={`click top tag: ${tagTitle}`}
              // TODO: Tag props needed?
              custom={{
                tagId: t.id,
                tagTitle: t.title,
              }}
              className="regular regular-tag"
              key={t.id}
              href={`/samling/${section}/${t.id}`}
            >
              {tagTitle}
            </LinkWithPulse>
          );
        })}
      </div>
    </div>
  );
};
